export const SAARLAND_BOUNDS = {
  minLat: 49.1119,
  maxLat: 49.6394,
  minLng: 6.3569,
  maxLng: 7.4037,
};

export const companyTypes = [
  "GmbH",
  "UG (haftungsbeschränkt)",
  "AG",
  "GmbH & Co. KG",
  "KG",
  "OHG",
  "GbR",
  "e.V.",
  "Stiftung",
  "KGaA",
  "SE",
];

export const companySizes = ["Klein", "Mittel", "Groß"];

export const BASIC_URL = process.env.REACT_APP_API_URL;
export const DOMAIN_URL = process.env.REACT_APP_DOMAIN_URL;

// Kartenkacheln vom eigenen Tileserver (nginx leitet /tiles/ an trasaar-tiles).
// Lokal ohne nginx: REACT_APP_TILE_URL in .env.local auf den Tileserver zeigen.
export const TILE_URL = process.env.REACT_APP_TILE_URL || '/tiles/{z}/{x}/{y}.png';
// Pflicht-Attribution: OSM-Daten (ODbL) UND das OpenMapTiles-Schema, auf dem
// das Kachel-Profil von planetiler beruht. Beide muessen sichtbar genannt werden.
export const TILE_ATTRIBUTION = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a>';

// Die Kacheln entstehen in zwei Ebenen (siehe trasaar-deployment/tiles/build-tiles.sh):
// bis TILE_SPLIT_ZOOM gibt es sie fuer Deutschland + Nachbarlaender, darueber nur
// noch fuer die Detailregion. Ohne diese beiden Angaben wuerde die Karte ausserhalb
// der Detailregion beim Hineinzoomen leer bleiben - der obere Kachel-Layer laedt
// dort nichts mehr und der untere wuesste nicht, dass er hochskalieren soll.
// Beide Werte muessen zu ZOOM_SPLIT und BBOX_DETAIL im Build-Skript passen.
export const TILE_SPLIT_ZOOM = Number(process.env.REACT_APP_TILE_SPLIT_ZOOM || 11);

// Die Kernregion, die immer vollstaendig sichtbar sein muss - auf jedem Geraet.
// Sie hat Vorrang vor einem randlos gefuellten Kartenbild: auf hohen, schmalen
// Displays (Mobil) wuerde die Forderung "Abdeckung fuellt den Bildschirm" den
// Zoom so weit hochtreiben, dass das Saarland nicht mehr aufs Bild passt.
// Format: "west,sued,ost,nord"
const coreBbox = (process.env.REACT_APP_MAP_CORE_BBOX || '6.35,49.11,7.41,49.64')
  .split(',')
  .map(Number);
export const MAP_CORE_BOUNDS = [
  [coreBbox[1], coreBbox[0]],
  [coreBbox[3], coreBbox[2]],
];

// Der gesamte Bereich, fuer den ueberhaupt Kacheln existieren (BBOX_KULISSE im
// Build-Skript). Daraus leitet die Karte ab, wie weit hinausgezoomt werden darf -
// sonst sieht man am Rand leere Flaeche. Format: "west,sued,ost,nord"
const coverageBbox = (process.env.REACT_APP_TILE_COVERAGE_BBOX || '3.00,46.20,16.50,55.80')
  .split(',')
  .map(Number);
export const TILE_COVERAGE_BOUNDS = [
  [coverageBbox[1], coverageBbox[0]],
  [coverageBbox[3], coverageBbox[2]],
];

// Format wie im Build-Skript: "west,sued,ost,nord"
const detailBbox = (process.env.REACT_APP_TILE_DETAIL_BBOX || '5.00,48.30,8.80,50.50')
  .split(',')
  .map(Number);
// Leaflet erwartet [[sued, west], [nord, ost]]
export const TILE_DETAIL_BOUNDS = [
  [detailBbox[1], detailBbox[0]],
  [detailBbox[3], detailBbox[2]],
];
